<template>
  <div>
    <page-navigate></page-navigate>
    <div class="appTg_section1">
      <div class="bgPart">

        <video class="lazyload pc" src="@/assets/image/AppTg/headerBg.mp4?t=4" muted loop autoplay></video>
        <video class=" mobile" src="@/assets/image/AppTg/headerBgM.mp4?t=1" muted loop autoplay playsinline
          webkit-playsinline x5-playsinline></video>

      </div>
      <div class="contentBox">
        <h1>
          <span>
            EBC App
          </span>
          <br />
          <span>您的移动交易终端</span>
        </h1>
        <div class="smPartNew ">
          <div class="smCodePart">
            <div class="smCode" id="qrcode"></div>
          </div>
          <div class="smWordPart">
            <div class="body-16_regular">扫一扫下载App</div>
            <img src="@/assets/image/AppTg/appleDw.svg" alt="">
            <img src="@/assets/image/AppTg/googleDw.svg" alt="">
          </div>
        </div>
        <div class="smPartNewMobile">
          <a href="https://ebc-app.onelink.me/ZJmK/2x3lslze" target="_blank">
            <img src="@/assets/image/AppTg/newSmBtnIcon.svg" alt="">
            <span>下载 EBC App</span>
          </a>
        </div>
      </div>
    </div>
    <div class="appTg_section2" id="appTg_section2">
      <div class="contentBox part1 flex justify-between items-center scroll-fade-up ">
        <div class="wordPart">
          <h2>账户管理一目了然</h2>
          <div class="accordion-item open">
            <button class="accordion-header">
              <span class="header-title">查看实时动态</span>
            </button>
            <div class="accordion-content">
              <div class="content-inner">
                <div class="content-text">
                  资金流转清晰可查，管理账户更高效、更便捷
                </div>
              </div>
            </div>
          </div>
          <div class="divider"></div>

          <div class="accordion-item">
            <button class="accordion-header">
              <span class="header-title">多账号管理</span>
            </button>
            <div class="accordion-content">
              <div class="content-inner">
                <div class="content-text">
                  无需反复登入，即可无缝管理所有交易账号
                </div>
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="accordion-item">
            <button class="accordion-header">
              <span class="header-title">便捷出入金</span>
            </button>
            <div class="accordion-content">
              <div class="content-inner">
                <div class="content-text">
                  随时随地出入金，资金流转快人一步
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modelPart">
          <video class="active lazyload" loop muted autoplay playsinline webkit-playsinline x5-playsinline
            src="@/assets/image/AppTg/s2Part1Model1.mp4" alt=""></video>
          <video class="lazyload" loop muted autoplay playsinline webkit-playsinline x5-playsinline
            src="@/assets/image/AppTg/s2Part1Model2.mp4?t=3" alt=""></video>
          <video class="lazyload" loop muted autoplay playsinline webkit-playsinline x5-playsinline
            src="@/assets/image/AppTg/s2Part1Model3.mp4?t=1" alt=""></video>
        </div>
      </div>
      <div class="mobile mobileDivider"></div>
      <div class="contentBox part2 flex justify-between items-center scroll-fade-up ">
        <div class="modelPart">
          <video src="@/assets/image/AppTg/s2Part2Model1.mp4" class="lazyload active" loop muted autoplay playsinline
            webkit-playsinline x5-playsinline></video>
          <video src="@/assets/image/AppTg/s2Part2Model2.mp4" class="lazyload" loop muted autoplay playsinline
            webkit-playsinline x5-playsinline></video>
        </div>
        <div class="wordPart">
          <h2>交易全球, 触手可及</h2>
          <div class="accordion-item open">
            <button class="accordion-header">
              <span class="header-title">一体化交易</span>
            </button>
            <div class="accordion-content">
              <div class="content-inner">
                <div class="content-text">资金状态、持仓信息、交易执行等同步更新，所有关键操作在同一个App内完成。</div>
              </div>
            </div>
          </div>
          <div class="divider"></div>

          <div class="accordion-item">
            <button class="accordion-header">
              <span class="header-title">毫秒级成交</span>
            </button>
            <div class="accordion-content">
              <div class="content-inner">
                <div class="content-text">通过机构级报价与执行，确保让您订单瞬时成交，锁定市场最优价格。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="appTg_section3">
      <div class="contentBox">
        <h2 class="title-40_bold md-subtitle-20_bold text-center scroll-fade-up ">您口袋里的全能账户管家</h2>
        <div class="s3CardList flex items-stretch flex-wrap scroll-fade-up ">
          <div class="s3Card borderR borderB">
            <img src="@/assets/image/AppTg/s3CardIcon1.png" alt="" />
            <div>
              <div class="title-24_medium md-body-16_medium cardTitle">便捷出入金</div>
              <div class="body-16_regular md-body-14_regular">随时随地出入金，资金流转快人一步</div>
            </div>
          </div>
          <div class="s3Card borderR borderB">
            <img src="@/assets/image/AppTg/s3CardIcon2.png" alt="" />
            <div>
              <div class="title-24_medium md-body-16_medium cardTitle">消息通知</div>
              <div class="body-16_regular md-body-14_regular">重要信息，第一时间推送至您手边</div>
            </div>

          </div>
          <div class="s3Card borderB">
            <img src="@/assets/image/AppTg/s3CardIcon3.png" alt="" />
            <div>
              <div class="title-24_medium md-body-16_medium cardTitle">市场分析</div>
              <div class="body-16_regular md-body-14_regular">实时获取全球资讯与专家观点</div>
            </div>

          </div>
          <div class="s3Card borderR">
            <img src="@/assets/image/AppTg/s3CardIcon4.png" alt="" />
            <div>
              <div class="title-24_medium md-body-16_medium cardTitle">跟单交易</div>
              <div class="body-16_regular md-body-14_regular">一键免费跟随高手交易</div>
            </div>

          </div>
          <div class="s3Card borderR">
            <img src="@/assets/image/AppTg/s3CardIcon5.png" alt="" />
            <div>
              <div class="title-24_medium md-body-16_medium cardTitle">热门活动</div>
              <div class="body-16_regular md-body-14_regular">EBC最新活动与福利，一键参与</div>
            </div>

          </div>
          <div class="s3Card">
            <img src="@/assets/image/AppTg/s3CardIcon6.png" alt="" />
            <div>
              <div class="title-24_medium md-body-16_medium cardTitle">在线客服</div>
              <div class="body-16_regular md-body-14_regular">24/7多语言专业客服团队支持</div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="appTg_section4">
      <div class="contentBox">
        <h2 class="title-40_bold md-subtitle-20_bold text-center scroll-fade-up ">只需三步，开启投资之旅</h2>
        <div class="s4Card scroll-fade-up ">
          <div class="leftTip">
            <div class="step-item active">
              <div class="step-circle">1</div>
              <div class="mobile">
                <div class="numStep flex justify-center items-center">1</div>
              </div>
              <div class="step-header">
                <div class="step-title-wrapper">
                  <div class="step-title">下载官方App</div>
                </div>
              </div>
              <div class="step-content">
                <div class="step-description">一键获取EBC官方应用</div>
              </div>
              <div class="step-divider"></div>
            </div>
            <div class="step-item">
              <div class="step-circle">2</div>
              <div class="mobile">
                <div class="numStep flex justify-center items-center">2</div>
              </div>
              <div class="step-header">

                <div class="step-title-wrapper">
                  <div class="step-title">3分钟极速开户</div>
                </div>

              </div>
              <div class="step-content">
                <div class="step-description">上传证件，完成身份认证</div>
              </div>
              <div class="step-divider"></div>
            </div>
            <div class="step-item">
              <div class="step-circle">3</div>
              <div class="mobile">
                <div class="numStep flex justify-center items-center">3</div>
              </div>
              <div class="step-header">

                <div class="step-title-wrapper">
                  <div class="step-title">入金交易</div>
                </div>

              </div>
              <div class="step-content">
                <div class="step-description">选择常用支付方式，轻松完成入金交易</div>
              </div>
            </div>
          </div>
          <div class="rightModel">
            <img class="lazyload active" src="@/assets/image/AppTg/s4Model1.webp?t=1" alt="" />
            <img class="lazyload" src="@/assets/image/AppTg/s4Model2.webp" alt="" />
            <img class="lazyload" src="@/assets/image/AppTg/s4Model3.webp" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="appTg_section5">
      <img class="bg lazyload pc" src="@/assets/image/AppTg/s5bg.webp" alt="" />
      <img class="bg lazyload mobile" src="@/assets/image/AppTg/s5bgM.webp" alt="" />
      <div class="contentBox">
        <div class="s5Container flex justify-between items-center  ">
          <div class="leftContainer flex items-center scroll-fade-up">
            <img class="lazyload" src="@/assets/image/AppTg/s5Logo.png" alt="" />
            <div>
              <div class="title-32_bold md-subtitle-20_bold">下载EBC App <br>交易从未如此简单</div>
              <!-- <div class="title-24_regular desc md-body-14_regular">iOS 苹果系统 和 Android 安卓系统</div> -->
            </div>
          </div>
         <div class="smPartBottom scroll-fade-up">
            <div class="smCodeBottom">
              <div id="qrcode2"></div>
            </div>
            <div class="body-14_regular text-center">扫码下载</div>
          </div>
          <div class="smPartNewMobile scroll-fade-up">
          <a href="https://ebc-app.onelink.me/ZJmK/2x3lslze" target="_blank">
            <img src="@/assets/image/AppTg/newSmBtnIcon.svg" alt="">
            <span>下载 EBC App</span>
          </a>
        </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>
<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import QRCode from 'qrcodejs2'
import { mapGetters } from 'vuex';
import 'swiper/css/swiper.css'
import Swiper from 'swiper'
export default {
  mixins: [fadeAnimate],
  data() {
    return {
      androidUrl: '',
      googleUrl: '',
      appleUrl: ''
    }
  },
  mounted() {
    this.initPage()
    // this.getApkURL()
  },
  methods: {

    getApkURL() {
      fetch('https://www.ebc.site/portal/AppInfo/getDownloadLink').then(res => res.json()).then(res => {
        this.androidUrl = res.data.android_download_link
        this.googleUrl = res.data.google_download_link
        this.appleUrl = res.data.ios_download_link
      })
    },
    initPage() {
      const isMobile = window.matchMedia('(max-width:996px)').matches
      const accordionConfigs = [
        {
          part: ".appTg_section2 .part1",
          media: ".modelPart video",
        },
        {
          part: ".appTg_section2 .part2",
          media: ".modelPart video",
        },
      ];

      // 通用初始化函数
      accordionConfigs.forEach(({ part, media }) => {
        const mediaElements = document.querySelectorAll(`${part} ${media}`);
        const items = document.querySelectorAll(`${part} .accordion-item`);

        items.forEach((header, index) => {
          header.addEventListener("click", () => {
            const currentItem = header.closest(".accordion-item");

            // 如果已展开则返回（保持至少一项展开）
            if (currentItem.classList.contains("open")) return;

            // 关闭同组内的其他项
            items.forEach((item, i) => {
              if (item !== currentItem) {
                item.classList.remove("open");
                mediaElements[i]?.classList.remove("active");
              }
            });

            // 展开当前项
            currentItem.classList.add("open");
            mediaElements[index]?.classList.add("active");
          });
        });
      });

      const stepItems = document.querySelectorAll(".appTg_section4 .step-item");
      const s4RightImg = document.querySelectorAll(".appTg_section4 .rightModel img");
      stepItems.forEach((item, outIndex) => {
        item.addEventListener("click", function () {
          const isActive = item.classList.contains("active");
          if (isActive) return
          stepItems.forEach((otherItem, index) => {
            if (otherItem !== item) {
              otherItem.classList.remove("active");
              s4RightImg[index]?.classList.remove("active");
            }
          });
          item.classList.add("active");
          s4RightImg[outIndex]?.classList.add("active");
        })

      });

    
      if (window.matchMedia('(min-width:996px)').matches) {
        new QRCode(document.getElementById("qrcode"), {
            text: 'https://ebc-app.onelink.me/ZJmK/2x3lslze',
            width: 128,
            height: 128,
            colorDark : "#000000",
            colorLight : "#ffffff",
            correctLevel : QRCode.CorrectLevel.H
        });
new QRCode(document.getElementById("qrcode2"), {
            text: 'https://ebc-app.onelink.me/ZJmK/2x3lslze',
            width: 128,
            height: 128,
            colorDark : "#000000",
            colorLight : "#ffffff",
            correctLevel : QRCode.CorrectLevel.H
        });

      }
    }
  },
  computed: {
    ...mapGetters([
      'signupUrl',
    ]),


  },
}
</script>
<style scoped lang="scss">
  .appTg_section1 {
  padding-block: 346rem 266rem;
  position: relative;
  background-color: #e5e7e9;
  box-sizing: border-box;
  
}
.appTg_section1 .smDownloadNew .innerQRCode  .smQRCode{
  display: none;
  margin-top: 12rem;
  width: 100%;
}
.appTg_section1 .smDownloadNew .innerQRCode  .smQRCode div:first-child{
  margin-inline: auto;
}
.firstSm{
  margin-bottom: 0!important;
  padding-inline: 0!important;
}
@media (min-width: 996px) {
  .appTg_section1 .smDownloadNew .QRCodeNew a:hover{
    background: rgba(0, 0, 0, 0.04);
  }
.appTg_section1 {
  height: 900rem;
  /* padding-block: 0; */
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.appTg_section1 .contentBox{
  width: 1200rem;
}

.appTg_section1 .smDownloadNew .innerQRCode .smQRCode #qrcode,
.appTg_section1 .smDownloadNew .innerQRCode .smQRCode #qrcode3,
.appTg_section1 .smDownloadNew .innerQRCode .smQRCode img{
  width: 110rem;
  height: 110rem;
  margin-bottom: 12rem;
}
.kr .firstSm .smQRCode div,
.hi .firstSm .smQRCode div
{
  white-space: nowrap;
}
.smDownloadNew .QRCodeNew .smQRCode div{
  color: var(--Text-Primary, #000);
  text-align: center;
  font-size: 14rem;
  font-weight: 400;
  line-height: 22rem; 
  display: block;
}

.appTg_section1 .smDownloadNew .QRCodeNew{
  padding-bottom: 24rem;
  gap: 0;
}

}
a {
  text-decoration: none;
}
.contentBox {
  max-width: 1200rem;
  margin-inline: auto;
}
.appTg_section1 .contentBox {
  position: relative;
  z-index: 3;
}
.appTg_section1 .bgPart {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}

.appTg_section1 .bgPart video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: bottom;
}
.ar .appTg_section1  .contentBox{
  text-align: right;
}
.ar .appTg_section1  .downloadPart {
  justify-content: flex-end!important;
  max-width: 680rem;
}

.appTg_section1 h1 {
  /* text-align: center; */
  font-size: 80rem;
  font-weight: 700;
  line-height: 90rem;
  margin-bottom: 72rem;
  max-width: 680rem;
}
.zh .appTg_section1 h1 {
  line-height: 100rem;
}

/* .appTg_section1 h1 span:nth-child(1) {
  font-size: 88rem;
} */
.appTg_section1 .downloadTitle {
  text-align: center;
  font-size: 24rem;
  font-style: normal;
  font-weight: 400;
  line-height: 32rem;
  margin-bottom: 32rem;
  display: none;
}
.appTg_section1 .smDownload{
  display: none;
}
.appTg_section1 .QRCodeBox {
  border-radius: var(--ebc-corner-radius-rc24);
  border: 1px solid #000;
  padding: 20rem;
  width: 140rem;
  height: 140rem;
  box-sizing: content-box;
}
.appTg_section1 .QRCodeBox img {
  width: 140rem;
  height: 140rem;
}
.appTg_section1 .appDownloadBox img {
  width: 22rem;
  height: 22rem;
}
.appTg_section1 .appDownloadBox:nth-of-type(3),
.appTg_section1 .appDownloadBox:nth-of-type(2){
  display: none;
}
.appTg_section1 .appDownloadBox {
  min-width: 182rem;
  padding: 16rem 32rem;
  border-radius: var(--ebc-corner-radius-full);
  background: var(--ebc-brand-secondary-red);
  gap: 12rem;
  color: var(--ebc-text-primary_white);
  font-size: 16rem;
  font-weight: 500;
  line-height: 28rem;
  margin-bottom: 12rem;
  height: 52rem;
  box-sizing: border-box;
}

.appTg_section1 .smDownloadNew {
  min-width: 182rem;
  display: flex;
  align-items: center;
  justify-content: center;
  
  border: 1px solid var(--ebc-brand-secondary-red);
  padding: 0rem 24rem;
  height: 52rem;
  box-sizing: border-box;
  border-radius: var(--ebc-corner-radius-full);
  position: relative;
  margin-left: 12rem;
  cursor: pointer;
}
.appTg_section1 .smDownloadNew div{
  display: flex;
  align-items: center;
  gap: 12rem;
 color: var(--ebc-brand-secondary-red);
  text-align: center;
  font-size: 16rem;
  font-weight: 500;
  line-height: 28rem; /* 175% */
}
.appTg_section1 .smDownloadNew div svg:nth-child(3){
  margin-left: 5rem;
}
.appTg_section1 .smDownloadNew .QRCodeNew{
  padding-top: 16rem;
}
.appTg_section1 .smDownloadNew .shadowBg{
  display: none;
  position: fixed;
  inset: 0;
  z-index: 10;
  background: rgba(10, 10, 10, 0.30);
  pointer-events: none;
}

.appTg_section1 .smDownloadNew .innerQRCode{
   border-radius: var(--Corner-Radius-RC24, 24px);
  background: var(--Neutral-BG_A, #FFF);
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.05);
  padding: 24rem;
  /* display: flex; */
  flex-direction: column;
  gap:12rem;
}
.appTg_section1 .smDownloadNew .innerQRCode img{
  width: 16rem;
  height: auto;
}

.appTg_section1 .smDownloadNew .QRCodeNew a{
  width: 170rem;
  height: 40rem;
  border-radius: var(--Corner-Radius-Full, 999px);
  border: 0.5px solid var(--Text-Tertiary, rgba(0, 0, 0, 0.48));
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8rem;
  color: var(--Text-Primary, #000);
  text-align: center;
  font-size: 14rem;
  font-weight: 500;
  line-height: normal;
}
.ar .appTg_section1 .smDownloadNew {
  margin-right: 12rem;
}

.appTg_section1 .smDownloadNew:hover .QRCodeNew{
  display: flex;
}
.appTg_section1 .smDownloadNew:hover {
  border-color: var(--ebc-basecolor-active-400);
}
.appTg_section1 .smDownloadNew:hover div:first-child{
  color: var(--ebc-basecolor-active-400);
}
.appTg_section1 .smDownloadNew:hover svg path{
  fill: var(--ebc-basecolor-active-400);
}
.appTg_section1 .smDownloadNew .QRCodeNew{
  display: none;
  position: absolute;
  padding-top: 16rem;
  left:0;
  bottom:0;
  transform: translate(0%,100%);
  flex-direction: column;
  
}


.appTg_section1 .appDownloadBox:last-child {
  margin-bottom: 0;
}
.appTg_section1 .appDownloadBox:hover {
  background: var(--ebc-basecolor-active-400);
}
@media (min-width: 996px) {
  .ru  .appTg_section1 .downloadPart .smDownload:first-child,
.mn  .appTg_section1 .downloadPart .smDownload:first-child{
  transform: translateY(-32rem);
}
.ru h1{
  line-height: 72rem;
}
}



@media (max-width: 996px) {
  .contentBox {
    margin-inline: 32rem;
  }
  .appTg_section1 {
    padding-block: 130rem 770rem;
  }
  .smDownloadNew{
    /* display: none!important; */
  }
  .appTg_section1 h1 {
    font-size: 64rem;
    font-weight: 700;
    line-height: 90rem;
    margin-bottom: 64rem;
    text-align: center;
  }
  .appTg_section1 h1 span:nth-child(1) {
    font-size: 80rem;
  }
  .appTg_section1 .downloadPart {
    justify-content: center;
    flex-direction: column;
    gap: 24rem;
  }
  .appTg_section1 .downloadPart .smDownload {
    display: none;
  }
  .appTg_section1 .downloadPart .appDownload {
    flex: 1;
    width: 100%;
  }
  .appTg_section1 .downloadTitle {
    font-size: 32rem;
    line-height: 48rem;
    margin-bottom: 30rem;
  }
  .appTg_section1 .appDownloadBox,
  .appTg_section1 .smDownloadNew
   {
    width: 100%;
    box-sizing: border-box;
    background: transparent;
    color: var(--ebc-text-primary_white);
    font-size: 32rem;
    font-weight: 500;
    line-height: 56rem;
    /* border: 1px solid #000; */
    padding-block: 28rem;
    gap: 24rem;
    height: 96rem;
    margin-bottom: 32rem;
    background: var(--ebc-brand-secondary-red);
    margin-left: 0;
  }
  .appTg_section1 .smDownloadNew.secondSm{
    background: transparent;
    border: 1px solid var(--ebc-brand-secondary-red);
  }
  .appTg_section1 .smDownloadNew.secondSm div{
    color: var(--ebc-brand-secondary-red);
  }
   .appTg_section1 .smDownloadNew.secondSm:hover{
    border-color: var(--ebc-basecolor-active-400);

   }
  .appTg_section1 .smDownloadNew.secondSm:hover div{
    color: var(--ebc-basecolor-active-400);
  }
  .appTg_section1 .smDownloadNew .QRCodeNew{
    position: fixed;
    width: 100vw;
    padding: 48rem 32rem 72rem;
    transform: unset;
    box-sizing: border-box;
    background-color: #fff;
    z-index: 20;
  }
  .appTg_section1 .smDownloadNew .QRCodeNew .innerQRCode{
    width: 100%;
    box-shadow: unset;
    padding: 0;
    gap: 32rem;
  }
  .appTg_section1 .smDownloadNew:hover .shadowBg{
      display: block;
  }
  .appTg_section1 .smDownloadNew .QRCodeNew a{
    width:100%;
    height: 96rem;
    gap: 24rem;
    color: var(--Text-Primary, #000);
    text-align: center;
    font-size: 32rem;
    font-weight: 500;
    line-height: 56rem; /* 175% */
  }
  
  .appTg_section1 .smDownloadNew .QRCodeNew a img{
    width: 40rem;
    height: auto;
  }
  .appTg_section1 .smDownloadNew>div:first-child{
    color: var(--ebc-brand-secondary-red);
    font-size: 32rem;
    font-weight: 500;
        gap: 24rem;

  }
  .appTg_section1 .smDownloadNew>div:first-child svg:last-child{
    display: none;
  }
   .appTg_section1 .appDownloadBox:hover {
    background: var(--ebc-brand-secondary-red);
  } 
  .appTg_section1 .appDownloadBox img {
    width: 40rem;
    height: 40rem;
  }
  .appTg_section1 .leftShadow,
  .appTg_section1 .rightShadow {
    display: none;
  }
  .appTg_section1 .bgPart video {
    object-fit: cover;
  }
}

.appTg_section2,
.appTg_section3,
.appTg_section4 {
  padding-block: 120rem;
}
.appTg_section2 .modelPart {
  flex: 0 0 644rem;
}

.appTg_section2 .modelPart video,
.appTg_section2 .modelPart img {
  display: none;
  width: 100%;
  height: 100%;
}
.appTg_section2 .modelPart video.active,
.appTg_section2 .modelPart img.active {
  display: block;
}
.appTg_section2 .wordPart {
  flex: 0 0 472rem;
}

@media (min-width: 996px) {
  .appTg_section2 .part1 .wordPart {
  order: 2;
}
.appTg_section2 .part2 .modelPart {
  order: 2;
}

}

@media (min-width: 996px) {
  .appTg_section2 .part2 .modelPart {
    transform: translateX(28rem);
    width: 644rem;
    height: 600rem;
  }
  .appTg_section2 .part1 .modelPart {
    transform: translateX(-30rem);
    width: 644rem;
    height: 640rem;
  }
  .ar .appTg_section2 .part2 .modelPart {
    transform: translateX(-28rem);

  }

  .ar .appTg_section2 .part1 .modelPart {
    transform: translateX(20rem);
  }
}
.appTg_section2 h2 {
  font-size: 40rem;
  font-weight: 700;
  line-height: 52rem;
}
.appTg_section2 .accordion-item {
  width: 100%;
  max-width: 600px;
  background: #ffffff;
  overflow: hidden;
  cursor: pointer;
}

.appTg_section2 .accordion-header {
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.appTg_section2 .accordion-item.open .header-title {
  color: var(--ebc-brand-secondary-red);
  padding-left: 16rem;
  position: relative;
  text-align: left;
}
.appTg_section2 .accordion-item.open .header-title::after {
  content: "";
  position: absolute;
  left: 2px;
  width: 2px;
  height: 24rem;
  top: 50%;
  transform: translateY(-50%);
  background: var(--ebc-brand-secondary-red);
}
.appTg_section2 .header-title {
  font-size: 24rem;
  font-weight: 500;
  line-height: 32rem;
  color: var(--ebc-text-primary);
}
.appTg_section2 .part2 .accordion-item.open .header-title::after {
  left: 0;
}
.appTg_section2 .arrow {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  color: #999;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: rotate(180deg);
}

.appTg_section2 .accordion-item.open .arrow {
  transform: rotate(0deg);
  color: #666;
}

.appTg_section2 .accordion-content {
  display: grid;
  grid-template-rows: 1fr;
}

.appTg_section2 .content-inner {
  overflow: hidden;
  min-height: 0;
}

.appTg_section2 .content-text {
  font-size: 16rem;
  line-height: 28rem;
  font-weight: 400;
  color: var(--ebc-text-secondary);
  padding-top: 8rem;
  padding-bottom: 15rem;
}

.appTg_section2 .divider {
  height: 1px;
  background: #e8e8e8;
  margin-bottom: 15px;
}

.appTg_section2 .part2 {
  margin-top: 120rem;
}
.appTg_section2 h2,
.appTg_section3 h2,
.appTg_section4 h2 {
  margin-bottom: 64rem;
}
@media (max-width: 996px) {
  .appTg_section2,
  .appTg_section3,
  .appTg_section4,
  .appTg_section5 {
    padding-block: 112rem !important;
  }
  .appTg_section3 h2,
  .appTg_section4 h2 {
    margin-bottom: 56rem;
    text-align: center;
  }

  .appTg_section2 h2 {
    margin-bottom: 766rem;
    text-align: center;
  }
  .appTg_section2 .part1,
  .appTg_section2 .part2 {
    flex-direction: column;
  }
  .appTg_section2 .part1 {
    margin-bottom: 80rem;
  }
  .appTg_section2 .wordPart {
    flex: 1;
    width: 100%;
  }
  .appTg_section2 .part1 .wordPart {
    order: 2;
  }
  .appTg_section2 .modelPart {
    flex: 1;
    margin-bottom: 56rem;
    position: absolute;
    transform: translateY(112rem);
    width: 100%;
  }
  .id .appTg_section2 .part1 .modelPart {
    transform: translateY(152rem);

  }
  .ru .appTg_section2 .part2 .modelPart ,
  .pt .appTg_section2 .part2 .modelPart {
    transform: translateY(152rem);
  }
  .appTg_section2 .modelPart video,
  .appTg_section2 .modelPart img {
    width: 100%;
  }
  .appTg_section2 .header-title {
    font-size: 32rem;
    line-height: 48rem;
  }
  .appTg_section2 .content-text {
    font-size: 28rem;
    line-height: 48rem;
    padding-block: 16rem;
  }
  .appTg_section2 .accordion-header {
    justify-content: center;
  }
  .appTg_section2 .accordion-item.open .header-title {
    padding-left: 24rem;
  }
  .appTg_section2 .accordion-item.open .header-title::after {
    width: 4rem;
    height: 32rem;
  }
  .appTg_section2 .accordion-item {
    text-align: center;
  }
  .appTg_section2 .accordion-item:nth-of-type(n + 2) {
    margin-top: 40rem;
  }
  .mobileDivider {
    height: 1px;
    width: auto;
    margin-inline: 32rem;
    background: var(--ebc-neutral-divider_regular);
  }

  .appTg_section2 .divider {
    display: none;
  }
}
.appTg_section3 {
  background: #2b2b33;
  color: #fff;
}
.appTg_section3 h2{
  color: #fff;
}

.appTg_section3 .s3Card {
  text-align: center;
  flex: 0 0 400rem;
  box-sizing: border-box;
  padding-inline: 20rem;
}
.appTg_section3 .s3Card:hover {
  background: rgba(255, 255, 255, 0.03);
}
.appTg_section3 .s3Card:nth-child(-n + 3) {
  padding-block: 41rem 56rem;
}
.appTg_section3 .s3Card:nth-child(n + 4) {
  padding-block: 56rem 41rem;
}
.borderR {
  border-right: 1px solid var(--ebc-neutral-divider_regular_white);
}
.ar .borderR{
  border-right: 0;
  border-left: 1px solid var(--ebc-neutral-divider_regular_white);
}
.borderB {
  border-bottom: 1px solid var(--ebc-neutral-divider_regular_white);
}
.appTg_section3 .s3Card img {
  width: 72rem;
  height: 72rem;
}

.appTg_section3 .s3Card .cardTitle {
  margin-block: 28rem 12rem;
}
.appTg_section3 .s3Card .cardTitle + div {
  color: var(--ebc-text-secondary_white);
}

@media (max-width: 996px) {
  .appTg_section3 .s3Card img {
    width: 112rem;
    height: 112rem;
  }
  .appTg_section3 .s3Card .cardTitle {
    margin-block: 0 16rem;
  }
  .zh .appTg_section3 .s3Card .cardTitle {
    margin-block: 24rem 16rem;
  }
  .appTg_section3 .s3Card {
    flex: 1 0 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40rem;
    border: 0;
    text-align: left;
  }
  .appTg_section3 .contentBox .s3Card {
    padding-block: 0;
    padding-left: 32rem;
  }
  .appTg_section3 .contentBox .s3Card div{
    text-align: center;
  }
  .appTg_section3 .contentBox .s3Card:hover{
    background: transparent;
  }
  .appTg_section3 .s3Card:nth-child(-n + 5) {
    margin-bottom: 80rem;
  }
  .zh .appTg_section3 .s3Card {
    flex: 0 0 342rem;
    display: block;
    margin-bottom: 0;
    text-align: center;
    padding-left: 0rem;
  }

  .zh .appTg_section3 .s3Card:nth-child(-n + 2) {
    padding-top: 34rem;
    padding-bottom: 96rem;
  }
  .zh .appTg_section3 .s3Card:nth-child(3),
  .zh .appTg_section3 .s3Card:nth-child(4) {
    padding-block: 96rem;
  }

  .zh .appTg_section3 .s3Card:nth-child(2n + 1) {
    padding-right: 56rem;
    border-right: 1px solid var(--ebc-neutral-stroke_white);
    border-bottom: 1px solid var(--ebc-neutral-stroke_white);
  }
  .zh .appTg_section3 .s3Card:nth-child(2n + 2) {
    padding-left: 56rem;
    border-bottom: 1px solid var(--ebc-neutral-stroke_white);
    border-right: 0;
  }
  .zh .appTg_section3 .s3Card:nth-child(n + 5) {
    padding-bottom: 34rem;
    padding-top: 96rem;
    border-bottom: 0;
  }
}

.appTg_section4 .s4Card {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.appTg_section4 .s4Card .leftTip {
  flex: 0 0 490rem;
}

.appTg_section4 .s4Card .rightModel {
  flex: 0 0 580rem;
  height: 480rem;
}
.appTg_section4 .step-item {
  position: relative;
  padding-left: 54rem;
  cursor: pointer;
}

.appTg_section4 .step-item:not(:last-child) {
  margin-bottom: 0;
  padding-bottom: 40rem;
}

.appTg_section4 .step-item::after {
  content: "";
  position: absolute;
  left: 19rem;
  top: 38rem;
  width: 1px;
  bottom: 0;
  background: #000;
  z-index: 1;
}

.appTg_section4 .step-item:last-child::after {
  display: none;
}

.appTg_section4 .step-circle {
  position: absolute;
  left: 0;
  top: 0;
  width: 38rem;
  height: 38rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  z-index: 2;
  background: #fff;
}

.appTg_section4 .step-item.active .step-circle {
  color: #fff;
  background: var(--ebc-brand-secondary-red);
}

.appTg_section4 .step-item:not(.active) .step-circle {
  border: 0.5px solid #000;
  color: #000;
}

.appTg_section4 .step-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  min-height: 38rem;
}
.appTg_section4 .step-item.active .step-title {
  color: var(--ebc-brand-secondary-red);
}

.appTg_section4 .step-title-wrapper {
  flex: 1;
}

.appTg_section4 .step-title {
  font-size: 24rem;
  line-height: 32rem;
  font-weight: 500;
  color: #000;
  margin-bottom: 0;
}

.appTg_section4 .step-subtitle {
  font-size: 16rem;
  line-height: 28rem;
  color: var(--ebc-text-secondary);
}

.appTg_section4 .step-content .step-subtitle {
  padding-top: 20rem;
  margin-bottom: 0;
}

.appTg_section4 .step-description {
  font-size: 16rem;
  line-height: 28rem;
  color: var(--ebc-text-secondary);
  padding-top: 0;
}

.appTg_section4 .step-content > .step-description:first-child {
  padding-top: 6rem;
}

.appTg_section4 .step-subtitle + .step-description {
  padding-top: 12rem;
}

.appTg_section4 .step-divider {
  height: 1px;
  background: #e0e0e0;
  margin-top: 40px;
  margin-bottom: 0;
}

.appTg_section4 .step-item:last-child .step-divider {
  display: none;
}

.appTg_section4 .rightModel img {
  display: none;
  width: 100%;
  height: auto;
}

.appTg_section4 .rightModel img.active {
  display: block;
}

@media (max-width: 996px) {
  .appTg_section4 .s4Card {
    flex-direction: column;
  }
  .appTg_section4 .s4Card .leftTip {
    flex: 1;
    order: 2;
    width: 100%;
    text-align: center;
    margin-top: 56rem;
  }
  .appTg_section4 .step-item::after,
  .appTg_section4 .step-item .step-circle {
    display: none;
  }
  .appTg_section4 .step-title {
    font-size: 32rem;
    line-height: 48rem;
  }
  .appTg_section4 .step-description {
    font-size: 28rem;
    line-height: 48rem;
  }
  .appTg_section4 .step-item {
    padding-left: 0;
  }
  .appTg_section4 .step-divider {
    margin-top: 56rem;
  }
  .appTg_section4 .step-content > .step-description:first-child {
    padding-top: 16rem;
  }
  .appTg_section4 .step-arrow {
    width: 20px;
    height: 20px;
  }
  .appTg_section4 .step-item:not(:last-child) {
    padding-bottom: 56rem;
  }
  .appTg_section4 .numStep {
    font-size: 40rem;
    font-weight: 700;
    line-height: 56rem;
    margin-bottom: 24rem;
    width: 38px;
    height: 38px;
    border-radius: var(--ebc-corner-radius-full);
    border: 1px solid var(--ebc-text-primary);
    margin-inline: auto;
  }
  .appTg_section4 .step-item.active .numStep {
    color: var(--ebc-text-primary_white);
    background: var(--ebc-brand-secondary-red);
    border: 1px solid var(--ebc-brand-secondary-red);
  }
}

.appTg_section5 {
  padding: 123rem 0;
  position: relative;
}

@media (min-width: 996px) {
  .s5Container {
    gap: 100rem;
  }
}
.appTg_section5 .bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
}

.appTg_section5 .leftContainer {
  gap: 40rem;
}
.appTg_section5 .leftContainer .desc {
  margin-top: 16rem;
}
.appTg_section5 .leftContainer img {
  width: 124rem;
  height: 124rem;
}

.appTg_section5 .rightBtn {
  min-width: 230rem;
  box-sizing: border-box;
}
.appTg_section5 .rightPart {
  position: relative;
  z-index: 9999;
}
.appTg_section5 .rightPart .hoverDial {
  display: none;
  position: absolute;
  bottom: 0;
  left: 7rem;
  transform: translateY(100%);
  padding-top: 16rem;
}
.appTg_section5 .rightPart .hoverDial .dialInner > img {
  width: 140rem;
  height: 140rem;
}
.appTg_section5 .rightPart .hoverDial .dialInner {
  border-radius: var(--ebc-corner-radius-rc24);
  background: #fff;
  padding: 24rem;
  gap: 24rem;
  flex-direction: column;
  min-width: 215rem;
  box-sizing: border-box;
  align-items: center;

}

@media (min-width: 996px) {
  .appTg_section5 .rightPart .hoverDial .dialInner {
    gap: 24rem;
    flex-direction: row;
    align-items: flex-start;
  }
  .appTg_section5 .rightPart .hoverDial .bottomSmCode{
    display: none;
  }
  .appTg_section5 .rightPart .hoverDial .bottomSmCode img,
  .appTg_section5 .rightPart .hoverDial .bottomSmCode #qrcode2{
    width: 110rem;
    height: 110rem;
    margin-bottom: 12rem;
  }
  .appTg_section5 .rightPart .hoverDial .bottomSmCode div{
    color: var(--Text-Primary, #000);
    text-align: center;
    font-size: 14rem;
    font-weight: 400;
    line-height: 22rem; /* 157.143% */
  }
}
.appTg_section5 .rightPart:hover .hoverDial {
  display: block;
}
.appTg_section5 .rightPart .hoverDial .downLoadList a:nth-child(-n + 2) {
  margin-bottom: 12rem;
  /* display: none; */
}

.appTg_section5 .rightPart .hoverDial .downLoadList a {
  border-radius: var(--ebc-corner-radius-full);
  border: 0.5px solid var(--ebc-text-tertiary);
  gap: 8rem;
  font-size: 14rem;
  font-weight: 500;
    min-width: 140rem;
    padding-inline: 25rem;
  white-space: nowrap;
  height: 40rem;
  box-sizing: border-box;
  color: #000;
}

.appTg_section5 .rightPart .hoverDial .downLoadList a:hover {
  background: rgba(0, 0, 0, 0.04);
}

.appTg_section5 .rightPart .hoverDial .downLoadList a img {
  width: 16rem;
  height: 16rem;
}

@media (max-width: 996px) {
  .appTg_section5 .s5Container {
    flex-direction: column;
    text-align: center;
  }
  .appTg_section5 .s5Container .leftContainer {
    flex-direction: column;
  }
  .appTg_section5 .leftContainer img {
    width: 140rem;
    height: 140rem;
  }
  .appTg_section5 .leftContainer {
    gap: 48rem;
  }
  .appTg_section5 .leftContainer .desc {
    margin-top: 8rem;
  }
  .appTg_section5 .mobileRight {
    font-size: 32rem;
    font-weight: 500;
    line-height: 56rem;
    width: 100%;
    margin-top: 64rem;
  }
  .appTg_section5 .mobileRight a {
    gap: 24rem;
    border-radius: var(--ebc-corner-radius-full);
    border: 1px solid var(--ebc-text-primary);
    width: 100%;
    height: 96rem;
    color: #000;
  }
  .appTg_section5 .mobileRight a:nth-child(-n + 2) {
    margin-bottom: 32rem;
    /* display: none; */
  }
  .appTg_section5 .mobileRight a img {
    width: 40rem;
    height: 40rem;
  }
}
.smPartNew{
  display: flex;
  align-items: center;
  gap:32rem
}

.smPartNew .smCodePart{
  width: 172rem;
  height: 170rem;
  padding: 20rem;
  box-sizing: border-box;
  border-radius: var(--ebc-corner-radius-rc12);
  border: 1px solid var(--ebc-text-quaternary);
  background: var(--ebc-neutral-bg_a, #FFF);
}
::v-deep(.smPartNew .smCodePart img){
  width: 100%;
  height: 100%;
}
.smPartNew .smWordPart img{
  width: 144rem;
  height: 44rem;
  display: block;
}
.smPartNew .smWordPart img:nth-child(2){
  margin-block: 24rem 10rem;
}

.smPartBottom{
  box-sizing: border-box;
  border-radius: var(--ebc-corner-radius-rc24);
  background: var(--ebc-neutral-bg_a);
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.05);
  width: 180rem;
  padding: 20rem 20rem 12rem;
}
::v-deep(.smPartBottom .smCodeBottom img){
  width: 140rem;
  height: 140rem;
}
.smPartBottom .smCodeBottom{
  margin-bottom: 8rem;
}
.smPartNewMobile{
  display: none;
}
@media (max-width: 996px) {
  .smPartBottom,.smPartNew{
    display: none;
  }
  .smPartNewMobile{
    display: block;
    width: 100%;
  }
  .smPartNewMobile a{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24rem;
    width: 100%;
    height: 80rem;
    font-size: 28rem;
    line-height: 56rem;
    color: var(--ebc-text-primary_white);
    background: var(--ebc-brand-secondary-red);
    border-radius: var(--ebc-corner-radius-full);
  }
  .smPartNewMobile img{
    width: 32rem;
    height: 32rem;
  }
  .appTg_section5  .smPartNewMobile{
    margin-top: 64rem;
  }

}
</style>